export default function SudokuCell({
  value,
  readOnly,
  borderClasses,
  hasError,
  isHintTarget,
  isSelected,
  isPeerCell,
  hasMatchingValue,
  noteValues = [],
  onSelect,
}) {
  const noteSet = new Set(noteValues.map((note) => String(note)));

  const cellClass = [
    'h-8 w-8 text-center text-sm font-semibold outline-none transition sm:h-9 sm:w-9 sm:text-base md:h-10 md:w-10 md:text-lg lg:h-11 lg:w-11',
    readOnly ? 'bg-slate-100 text-slate-900' : 'bg-white text-slate-700',
    isPeerCell ? 'bg-cyan-50' : '',
    hasMatchingValue ? 'bg-cyan-100 text-slate-900' : '',
    hasError ? 'bg-rose-100 text-rose-700' : '',
    isHintTarget ? 'bg-amber-100 text-amber-700' : '',
    isSelected ? 'relative z-10 ring-2 ring-inset ring-brand-cyan bg-cyan-100 text-slate-900' : '',
    !readOnly ? 'focus:bg-cyan-100 focus:text-slate-900' : '',
    borderClasses,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className="flex items-center justify-center">
      <button
        type="button"
        onClick={onSelect}
        className={`${cellClass} flex items-center justify-center`}
        aria-label={
          value
            ? `${readOnly ? 'Given' : 'Filled'} cell with value ${value}`
            : noteValues.length
              ? `Cell with notes ${noteValues.join(', ')}`
              : 'Empty Sudoku cell'
        }
      >
        {value ? (
          <span>{value}</span>
        ) : noteValues.length ? (
          <span className="grid h-full w-full grid-cols-3 grid-rows-3 gap-px px-0.5 py-0.5 text-[7px] font-medium text-slate-500 sm:text-[8px] md:text-[9px]">
            {Array.from({ length: 9 }, (_, index) => {
              const label = String(index + 1);

              return (
                <span key={label} className="flex items-center justify-center">
                  {noteSet.has(label) ? label : ''}
                </span>
              );
            })}
          </span>
        ) : null}
      </button>
    </div>
  );
}
